export const stringifyReqObj = (obj: any) => {
	return JSON.stringify(obj).replace(/"([^(")"]+)":/g, '$1:');
};
